import type { NativeDropType } from "#public"

import { WindowFileDrop } from "../internal/WindowFileDrop"
import { IngestFiles } from "../public/utils/IngestFiles"

// The web build's half of the window drop contract (the desktop build's is
// ../electron/NativeDrop). Catching the gesture is
// WindowFileDrop's job — all that is left here is what a dropped file
// becomes on the web: bytes through IngestFiles on the engine handed in,
// the same conversion a host's file picker uses.
export const NativeDrop: NativeDropType = async (engine, { on_dragging, on_files }) =>
  WindowFileDrop({
    on_dragging,
    on_files: files => void IngestFiles(engine, files).then(on_files),
  })
